<div class="main-container">
  <form [formGroup]="ticketDashboardSearchForm" novalidate>
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title"
          >My AIS 140 Tickets
          <app-info-tooltip
            heading="My AIS 140 Tickets"
            [description]="
              MyActivationsViewMasterAccess
                ? 'You have Master Access - this list shows tickets across all ticket handlers.'
                : 'This list only shows tickets assigned to you. Master Access is required to view tickets assigned to other ticket handlers.'
            "
          ></app-info-tooltip
        ></span>
      </div>
      <!-- Redirect Button -->
      <div class="button-group">
        @if (
          Server_Monitoring_Dashboard_View ||
          Certification_Automation_View ||
          Vahan_Tagging_Automation_View ||
          Dealer_Master_View ||
          Institutional_Sales_View ||
          MyActivationsUpdateMasterAccess
        ) {
          <button class="primary-button" (click)="openOtherLinksPopUp()">
            Other Links<mat-icon class="btn-icon">work</mat-icon>
          </button>
        }
        <app-ticketing-info></app-ticketing-info>
      </div>
    </div>

    <!-- KPI Section -->
    <div class="kpi-section">
      <!-- All Tickets -->
      <div
        class="kpi-card kpi-gradient-blue"
        (click)="fetchData('ALL')"
        tabindex="0"
        (keydown.enter)="fetchData('ALL')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >ALL
            <app-info-tooltip
              block
              heading="ALL"
              [description]="kpiInfo.all"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (allCount ? allCount : 0) | indianNumber }}</span
          >
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/all-tasks.png"
            alt="ALL Image"
          />
        </div>
      </div>

      <!-- IN PROGRESS Tickets-->
      <div
        class="kpi-card kpi-gradient-orange"
        (click)="fetchData('PRO')"
        tabindex="0"
        (keydown.enter)="fetchData('PRO')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >IN PROGRESS
            <app-info-tooltip
              block
              heading="IN PROGRESS"
              [description]="kpiInfo.inProgress"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">{{
            (inProgress ? inProgress : 0) | indianNumber
          }}</span>
        </div>
        <div class="kpi-visual">
          <img
            src="../../assets/in-progress-task.png"
            alt="IN PROGRESS Image"
          />
        </div>
      </div>

      <!--On Hold Tickets-->
      <div
        class="kpi-card kpi-gradient-yellow"
        (click)="fetchData('HOLD')"
        tabindex="0"
        (keydown.enter)="fetchData('HOLD')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >ON HOLD
            <app-info-tooltip
              block
              heading="ON HOLD"
              [description]="kpiInfo.onHold"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (onHold ? onHold : 0) | indianNumber }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/onHold-task.png"
            alt="ON HOLD Image"
          />
        </div>
      </div>
      <!-- CANCELLED Tickets-->
      <div
        class="kpi-card kpi-gradient-pink"
        (click)="fetchData('CAN')"
        tabindex="0"
        (keydown.enter)="fetchData('CAN')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >CANCELLED
            <app-info-tooltip
              block
              heading="CANCELLED"
              [description]="kpiInfo.cancelled"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (cancelled ? cancelled : 0) | indianNumber }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/cancelled-task.png"
            alt="CANCELLED Image"
          />
        </div>
      </div>

      <!-- Completed Tickets -->
      <div
        class="kpi-card kpi-gradient-green"
        (click)="fetchData('COM')"
        tabindex="0"
        (keydown.enter)="fetchData('COM')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >COMPLETED
            <app-info-tooltip
              block
              heading="COMPLETED"
              [description]="kpiInfo.completed"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (completed ? completed : 0) | indianNumber }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            loading="lazy"
            src="../../assets/completed-task.png"
            alt="COMPLETED Image"
          />
        </div>
      </div>
    </div>

    <!-- Ticket List -->
    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">{{ table_title }} Tickets List</h6>
        <div class="component-actions">
          <button class="primary-button" (click)="filterDropdownMenus()">
            Filter<mat-icon class="btn-icon">filter_list</mat-icon>
          </button>
          <app-common-search
            [initialSearchValue]="
              ticketDashboardSearchForm?.get('ticketDashboardSearch')?.value
            "
            matTooltip="Ticket NO. | UIN NO. | Chassis NO. | IMEI NO. | ICCID NO. | Ticket Description"
            [enableBulkSearch]="true"
            (searchSubmit)="onSearch($event)"
            (bulkSearchSubmit)="onBulkSearch($event)"
          ></app-common-search>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              @if (MyActivationsEdit || MyActivationsUpdateMasterAccess) {
                <th>
                  <input
                    type="checkbox"
                    aria-label="Select all tickets on this page"
                    [checked]="isCurrentPageFullySelected()"
                    [indeterminate]="isCurrentPagePartiallySelected()"
                    [disabled]="!listOfData.length"
                    (change)="toggleSelectAllTickets($event)"
                  />
                </th>
              }
              <th>Ticket NO.</th>
              <th>UIN NO.</th>
              <th>Chassis NO.</th>
              <th>RTO State</th>
              <th>Device Type</th>
              <th>Initiated By</th>
              @if (MyActivationsViewMasterAccess) {
                <th>Ticket Handler</th>
              }
              <th>Ticket Status</th>
              <th>Ticket Remark</th>
              <th>Start Date</th>
              <th>End Date</th>
              @if (
                MyActivationsView ||
                MyActivationsEdit ||
                MyActivationsViewMasterAccess ||
                MyActivationsUpdateMasterAccess
              ) {
                <th>Action</th>
              }
            </tr>
          </thead>
          @if (totalLength !== 0) {
            <tbody>
              @for (
                item of listOfData
                  | paginate
                    : {
                        id: 'batchPaginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track item
              ) {
                <tr>
                  @if (MyActivationsEdit || MyActivationsUpdateMasterAccess) {
                    <td>
                      <input
                        type="checkbox"
                        [checked]="assignToTicketList.includes(item._id)"
                        [disabled]="!canEditTicket(item)"
                        value=""
                        (change)="onViewChange($event, item._id)"
                      />
                    </td>
                  }
                  <td>{{ item.ticketNo ? item.ticketNo : '--' }}</td>
                  <td>{{ item.uid ? item.uid : '--' }}</td>
                  <td>{{ item.vinNo ? item.vinNo : '--' }}</td>
                  <td>{{ item.rtoState ? item.rtoState : '--' }}</td>
                  <td>
                    {{
                      item.deviceType === 'ATCU2G'
                        ? 'TCU2G'
                        : item.deviceType === 'ATCU4G'
                          ? 'TCU4G'
                          : '--'
                    }}
                  </td>
                  <td>
                    {{
                      item.InstitutionalSales
                        ? 'Institutional Sales'
                        : 'TML CRM & FE'
                    }}
                  </td>
                  @if (MyActivationsViewMasterAccess) {
                    <td>
                      {{ item.assignedUser ? item.assignedUser : '--' }}
                    </td>
                  }
                  <td>
                    {{
                      item.remarkbyaccolade
                        ? simplifiedTicketStatus[item.remarkbyaccolade]
                        : '--'
                    }}
                  </td>
                  <td>
                    {{ item.remark ? item.remark : '--' }}
                  </td>
                  <td>
                    {{
                      item.assignDate
                        ? (item.assignDate | date: 'dd MMM yyyy | hh:mm a')
                        : '--'
                    }}
                  </td>
                  <td>
                    {{
                      item.ticketEndDate
                        ? (item.ticketEndDate | date: 'dd MMM yyyy | hh:mm a')
                        : '--'
                    }}
                  </td>
                  @if (
                    MyActivationsView ||
                    MyActivationsEdit ||
                    MyActivationsViewMasterAccess ||
                    MyActivationsUpdateMasterAccess
                  ) {
                    <td>
                      <div class="action-buttons">
                        @if (
                          MyActivationsView || MyActivationsViewMasterAccess
                        ) {
                          @if (item.remarkbyaccolade !== 'STS_CO_19') {
                            <button
                              class="primary-button view-button"
                              (click)="viewTicket(item._id, item.uid)"
                            >
                              <mat-icon class="btn-icon">visibility</mat-icon>
                            </button>
                          }
                        }
                        @if (
                          MyActivationsEdit || MyActivationsUpdateMasterAccess
                        ) {
                          <button
                            class="primary-button edit-button"
                            (click)="updateTicketPopupClicked(item)"
                            [disabled]="!canEditTicket(item)"
                          >
                            <mat-icon class="btn-icon">edit</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  }
                </tr>
              }
            </tbody>
          }
          @if (totalLength === 0) {
            <tbody>
              <tr>
                <td colspan="15">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                    tabindex="0"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        @if (totalLength !== 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>

    <!-- Bulk Ticket Update -->
    @if (MyActivationsEdit || MyActivationsUpdateMasterAccess) {
      <div class="component-container">
        <form [formGroup]="updateBulkTicketForm">
          <!-- Component Header Section -->
          <div class="component-header">
            <h6 class="component-title">Bulk Ticket Update</h6>
          </div>
          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>
          <!-- Component Body Section -->
          <div class="component-body">
            <div class="form-section">
              <div class="form-group">
                <label for="Count" class="form-label"
                  >Selected Ticket Count</label
                >
                <mat-form-field appearance="outline">
                  <mat-label>Selected Ticket Count</mat-label>
                  <input
                    matInput
                    type="text"
                    readonly
                    [value]="assignToTicketList.length"
                  />
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="certificateExpiry" class="form-label"
                  >Ticket Status</label
                >
                <mat-form-field appearance="outline">
                  <mat-label>Ticket Status</mat-label>
                  <mat-select
                    #bulkEditFormTicketStatusSelect
                    formControlName="remarkbyaccolade"
                  >
                    @if (bulkEditFormTicketStatusSelect.focused) {
                      <mat-option>
                        <ngx-mat-select-search
                          placeholderLabel="Filter"
                          [formControl]="bulkEditFormTicketStatusFilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          (filteredReturn)="
                            bulkEditFormFilteredListOfTicketStatus = $event
                          "
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                    }
                    @for (
                      item of bulkEditFormFilteredListOfTicketStatus;
                      track item
                    ) {
                      <mat-option [value]="item.statusCode">
                        {{ item.status }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (
                    updateBulkTicketForm.controls['remarkbyaccolade'].touched &&
                    updateBulkTicketForm.controls['remarkbyaccolade'].errors
                      ?.required
                  ) {
                    <mat-error> This field is mandatory. </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="certificateExpiry" class="form-label">Remark</label>
                <mat-form-field appearance="outline">
                  <mat-label>Remark</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="remark"
                    [matAutocomplete]="remarkAuto1"
                    type="text"
                  />
                  <mat-autocomplete #remarkAuto1="matAutocomplete">
                    @for (
                      option of filteredRemarks(
                        updateBulkTicketForm.get('remark')?.value
                      );
                      track option
                    ) {
                      <mat-option [value]="option">
                        {{ option }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              @if (
                updateBulkTicketForm.value.remarkbyaccolade === 'STS_CO_18'
              ) {
                <!-- Certificate File Uploads -->
                <div class="form-group">
                  <label for="fileNames" class="form-label"
                    >Certificate File Uploads</label
                  >
                  <mat-form-field
                    class="file-upload-container"
                    appearance="outline"
                  >
                    <mat-label>Certificate File Uploads</mat-label>

                    <!-- Display File Name or Placeholder -->
                    <input
                      matInput
                      type="text"
                      formControlName="fileNames"
                      [value]="updateBulkTicketForm.controls['fileNames'].value"
                      readonly
                    />

                    <!-- Hidden File Input -->
                    <input
                      type="file"
                      accept=".pdf"
                      multiple
                      aria-label="File"
                      class="d-none"
                      (change)="onFileChange($event, 'bulk')"
                      #fileInput
                    />

                    <!-- Custom Upload Button -->
                    <button
                      mat-button
                      class="upload-btn"
                      (click)="fileInput.click()"
                      type="button"
                    >
                      <mat-icon>attach_file</mat-icon>
                    </button>

                    <!-- Error Message -->
                    @if (
                      updateBulkTicketForm.controls['fileNames'].touched &&
                      updateBulkTicketForm.controls['fileNames'].errors
                        ?.required
                    ) {
                      <mat-error> This field is Mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
              }
            </div>
          </div>

          <!-- Separator between Body and Footer -->
          <div class="component-separator"></div>

          <div class="component-footer">
            <div class="button-group">
              <button
                type="button"
                [disabled]="
                  assignToTicketList.length === 0 || !updateBulkTicketForm.valid
                "
                (click)="submitBulkUpdate()"
                class="submit-button"
              >
                Submit <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
              <button
                type="button"
                (click)="clearBulkUpdate()"
                class="clear-button"
              >
                Clear <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    }

    <!-- Assign Tickets Section -->
    @if (MyActivationsUpdateMasterAccess) {
      <div class="component-container">
        <form [formGroup]="ticketAssignedToForm">
          <!-- Component Header Section -->
          <div class="component-header">
            <h6 class="component-title">Reassign Tickets</h6>
          </div>
          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>
          <!-- Component Body Section -->
          <div class="component-body">
            <div class="form-section">
              <div class="form-group">
                <label for="Count" class="form-label"
                  >Selected Ticket Count</label
                >
                <mat-form-field appearance="outline">
                  <mat-label>Selected Ticket Count</mat-label>
                  <input
                    matInput
                    type="text"
                    readonly
                    [value]="assignToTicketList.length"
                  />
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="assignTo" class="form-label">Assign To</label>
                <mat-form-field appearance="outline">
                  <mat-label> Assign To</mat-label>
                  <mat-select #assignedUserSelect formControlName="assignTo">
                    @if (assignedUserSelect.focused) {
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="userNameFilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          placeholderLabel="Filter"
                          (filteredReturn)="filteredListOfAssignedUser = $event"
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                    }
                    @for (item of filteredListOfAssignedUser; track item) {
                      <mat-option [value]="item._id">
                        {{ item.fullName }}</mat-option
                      >
                    }
                  </mat-select>
                  @if (
                    ticketAssignedToForm.controls['assignTo'].touched &&
                    ticketAssignedToForm.controls['assignTo'].errors?.required
                  ) {
                    <mat-error> This field is mandatory. </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Separator between Body and Footer -->
          <div class="component-separator"></div>

          <div class="component-footer">
            <div class="button-group">
              <button
                [disabled]="
                  assignToTicketList.length === 0 ||
                  !ticketAssignedToForm.controls['assignTo'].value
                "
                (click)="saveAssignedTo()"
                class="submit-button"
              >
                Submit <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
              <button
                type="button"
                (click)="clearAssignedTo()"
                class="clear-button"
              >
                Clear <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    }

    <!-- Filter Details -->
    <div class="custom-container">
      <div class="custom-modal custom-modal-m" id="filterDetails">
        <div class="custom-modal-dialog">
          <div class="custom-modal-content">
            <!-- Modal Header -->
            <div class="custom-modal-header">
              <h4 class="custom-modal-title">
                Ticket Dashboard Details Filters
              </h4>
              <button
                type="button"
                class="custom-close-btn"
                (click)="closeModal()"
              >
                &times;
              </button>
            </div>
            <!-- Modal Body -->
            <form [formGroup]="reportsDashboardForm" novalidate>
              <div class="custom-modal-body">
                <div class="component-container">
                  <div class="component-body">
                    <div class="form-section">
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>T.Assign At: From Date</mat-label>
                          <input
                            formControlName="fromDate"
                            matInput
                            [matDatepicker]="fromDate"
                            id="fromDate"
                            placeholder="T.Assign At: From Date"
                            [max]="reportsDashboardForm.value.toDate || maxDate"
                            readonly
                          />

                          <mat-datepicker-toggle matSuffix [for]="fromDate">
                          </mat-datepicker-toggle>
                          <mat-datepicker #fromDate></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>T.Assign At: To Date</mat-label>
                          <input
                            formControlName="toDate"
                            matInput
                            [matDatepicker]="toDate"
                            id="toDate"
                            placeholder="T.Assign At: To Date"
                            [max]="maxDate"
                            [min]="reportsDashboardForm.value.fromDate || ''"
                            readonly
                          />

                          <mat-datepicker-toggle matSuffix [for]="toDate">
                          </mat-datepicker-toggle>
                          <mat-datepicker #toDate></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>T.Completed At: From Date</mat-label>
                          <input
                            formControlName="ticketCompletedAtFromDate"
                            matInput
                            [matDatepicker]="ticketCompletedAtFromDate"
                            id="ticketCompletedAtFromDate"
                            placeholder="T.Completed At: From Date"
                            [max]="
                              reportsDashboardForm.value
                                .ticketCompletedAtToDate || maxDate
                            "
                            readonly
                          />

                          <mat-datepicker-toggle
                            matSuffix
                            [for]="ticketCompletedAtFromDate"
                          >
                          </mat-datepicker-toggle>
                          <mat-datepicker
                            #ticketCompletedAtFromDate
                          ></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>T.Completed At: To Date</mat-label>
                          <input
                            formControlName="ticketCompletedAtToDate"
                            matInput
                            [matDatepicker]="ticketCompletedAtToDate"
                            id="ticketCompletedAtToDate"
                            placeholder="T.Completed At: To Date"
                            [max]="maxDate"
                            [min]="
                              reportsDashboardForm.value
                                .ticketCompletedAtFromDate || ''
                            "
                            readonly
                          />

                          <mat-datepicker-toggle
                            matSuffix
                            [for]="ticketCompletedAtToDate"
                          >
                          </mat-datepicker-toggle>
                          <mat-datepicker
                            #ticketCompletedAtToDate
                          ></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>State</mat-label>
                          <mat-select #stateSelect formControlName="state">
                            @if (stateSelect.focused) {
                              <mat-option>
                                <ngx-mat-select-search
                                  [formControl]="stateNameFilterCtrl"
                                  [noEntriesFoundLabel]="'No options found'"
                                  placeholderLabel="Filter"
                                  (filteredReturn)="
                                    filteredListOfState = $event
                                  "
                                >
                                </ngx-mat-select-search>
                              </mat-option>
                            }
                            @for (item of filteredListOfState; track item) {
                              <mat-option [value]="item.value">
                                {{ item.name }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Assigned To</mat-label>
                          <mat-select
                            #assignedUserSelect
                            formControlName="assignTo"
                          >
                            @if (assignedUserSelect.focused) {
                              <mat-option>
                                <ngx-mat-select-search
                                  [formControl]="userNameFilterCtrl"
                                  [noEntriesFoundLabel]="'No options found'"
                                  placeholderLabel="Filter"
                                  (filteredReturn)="
                                    filteredListOfAssignedUser = $event
                                  "
                                >
                                </ngx-mat-select-search>
                              </mat-option>
                            }
                            @for (
                              item of filteredListOfAssignedUser;
                              track item
                            ) {
                              <mat-option [value]="item._id">
                                {{ item.fullName }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Ticket Status</mat-label>
                          <mat-select
                            #ticketStatusSelect
                            formControlName="ticketStatusFilter"
                          >
                            @if (ticketStatusSelect.focused) {
                              <mat-option>
                                <ngx-mat-select-search
                                  placeholderLabel="Filter"
                                  [formControl]="ticketStatusFilterCtrl"
                                  [noEntriesFoundLabel]="'No options found'"
                                  (filteredReturn)="
                                    filteredListOfTicketStatus = $event
                                  "
                                >
                                </ngx-mat-select-search>
                              </mat-option>
                            }
                            @for (
                              item of filteredListOfTicketStatus;
                              track item
                            ) {
                              <mat-option [value]="item.statusCode">
                                {{ item.status }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Dealer</mat-label>
                          <mat-select
                            #dealerSelect
                            formControlName="dealerCode"
                          >
                            @if (dealerSelect.focused) {
                              <mat-option>
                                <ngx-mat-select-search
                                  [formControl]="dealerCodeFilterCtrl"
                                  [noEntriesFoundLabel]="'No options found'"
                                  placeholderLabel="Filter"
                                  (filteredReturn)="
                                    filteredListOfDealers = $event
                                  "
                                  onkeydown="return (event.keyCode!=13)"
                                >
                                </ngx-mat-select-search>
                              </mat-option>
                            }
                            @for (item of filteredListOfDealers; track item) {
                              <mat-option [value]="item.dealercode">
                                {{ item.posCode }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Initiated By</mat-label>
                          <mat-select formControlName="initiatedBy">
                            @for (item of initiatedByList; track item) {
                              <mat-option [value]="item.initiatedByValue">
                                {{ item.initiatedByName }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Device Type</mat-label>
                          <mat-select formControlName="deviceType">
                            @for (item of deviceTypeList; track item) {
                              <mat-option [value]="item.deviceTypeValue">
                                {{ item.deviceTypeName }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>TAT Type</mat-label>
                          <mat-select formControlName="tatType">
                            @for (item of tatTypeList; track item) {
                              <mat-option [value]="item.tatTypeValue">
                                {{ item.tatTypeName }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <!-- Separator between Body and Footer -->
                  <div class="component-separator"></div>

                  <div class="component-footer">
                    <div class="button-group">
                      @if (hierarchyLevel === 0) {
                        <button
                          class="primary-button"
                          (click)="resendTicketStatus()"
                          type="button"
                        >
                          Resend Ticket Status
                          <mat-icon class="btn-icon">download</mat-icon>
                        </button>
                      }
                      <button
                        [disabled]="totalLength === 0 || isDownloading"
                        class="primary-button"
                        (click)="downloadTicketDetailsReport()"
                        type="button"
                      >
                        Download Ticket Details
                        <mat-icon class="btn-icon">download</mat-icon>
                      </button>

                      <button
                        type="button"
                        class="submit-button"
                        (click)="getFilterResult()"
                      >
                        Submit
                        <mat-icon class="btn-icon">check_circle</mat-icon>
                      </button>

                      <button
                        type="button"
                        class="clear-button"
                        (click)="clear()"
                      >
                        Clear <mat-icon class="btn-icon">clear</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- Other Links -->
  <div class="custom-container">
    <div class="custom-modal custom-modal-m" id="otherLinksPopUp">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <!-- Modal Header -->
          <div class="custom-modal-header">
            <h4 class="custom-modal-title">Other Links</h4>
            <button
              type="button"
              class="custom-close-btn"
              (click)="closeOtherLinksModal()"
            >
              &times;
            </button>
          </div>
          <!-- Modal Body -->
          <div class="custom-modal-body">
            <div class="component-container">
              <div class="links-grid">
                @if (Server_Monitoring_Dashboard_View) {
                  <button
                    class="link-card"
                    (click)="openExternal('http://20.197.49.102:8501/')"
                  >
                    <div class="link-card-content">
                      <div class="link-title">Server Monitoring Dashboard</div>
                      <div class="link-subtitle">
                        State Server Health Monitoring
                      </div>
                    </div>
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }

                @if (Certification_Automation_View) {
                  <button
                    class="link-card"
                    (click)="openExternal('http://20.197.49.102:4173/')"
                  >
                    <div class="link-card-content">
                      <div class="link-title">Certification Automation</div>
                      <div class="link-subtitle">
                        Manage Certification Process
                      </div>
                    </div>
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }

                @if (Vahan_Tagging_Automation_View) {
                  <button
                    class="link-card"
                    (click)="
                      openExternal(
                        'http://98.70.50.95:8080/login?from=%2Fblue%2Forganizations%2Fjenkins%2FVahan_tag_automation%2Factivity'
                      )
                    "
                  >
                    <div class="link-card-content">
                      <div class="link-title">Vahan Tagging Automation</div>
                      <div class="link-subtitle">Automation Dashboard</div>
                    </div>
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }

                @if (Institutional_Sales_View) {
                  <button
                    class="link-card"
                    (click)="redirect('/institutional-sales')"
                  >
                    <div class="link-card-content">
                      <div class="link-title">Institutional Sales</div>
                      <div class="link-subtitle">Manual Ticket Management</div>
                    </div>
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }

                @if (MyActivationsUpdateMasterAccess) {
                  <button
                    class="link-card"
                    (click)="redirect('/ticket-assignment-page')"
                  >
                    <div class="link-card-content">
                      <div class="link-title">Ticket Assignment Master</div>
                      <div class="link-subtitle">Ticket Assignment Master</div>
                    </div>
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }

                @if (Dealer_Master_View) {
                  <button
                    class="link-card"
                    (click)="redirect('/dealer-master')"
                  >
                    <div class="link-card-content">
                      <div class="link-title">Dealer Master</div>
                      <div class="link-subtitle">Dealer Management</div>
                    </div>
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Update Ticket Popup -->
  <div class="custom-container">
    <div class="custom-modal custom-modal-m" id="updateTicketPopup">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <!-- Modal Header -->
          <div class="custom-modal-header">
            <h4 class="custom-modal-title">Update Ticket</h4>
            <button
              type="button"
              class="custom-close-btn"
              (click)="closeUpdateTicketPopupModal()"
            >
              &times;
            </button>
          </div>
          <!-- Modal Body -->
          <form [formGroup]="updateTicketForm" novalidate>
            <div class="custom-modal-body">
              <div class="component-container">
                <div class="component-body">
                  <div class="form-section">
                    <div class="form-group">
                      <label for="certificateExpiry" class="form-label"
                        >Ticket Number</label
                      >
                      <mat-form-field appearance="outline">
                        <mat-label>Ticket Number</mat-label>
                        <input
                          matInput
                          readonly
                          type="text"
                          formControlName="ticketNo"
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-group">
                      <label for="certificateExpiry" class="form-label"
                        >Ticket Status</label
                      >
                      <mat-form-field appearance="outline">
                        <mat-label>Ticket Status</mat-label>
                        <mat-select
                          #editFormTicketStatusSelect
                          formControlName="remarkbyaccolade"
                        >
                          @if (editFormTicketStatusSelect.focused) {
                            <mat-option>
                              <ngx-mat-select-search
                                placeholderLabel="Filter"
                                [formControl]="editFormTicketStatusFilterCtrl"
                                [noEntriesFoundLabel]="'No options found'"
                                (filteredReturn)="
                                  editFormFilteredListOfTicketStatus = $event
                                "
                              >
                              </ngx-mat-select-search>
                            </mat-option>
                          }
                          @for (
                            item of editFormFilteredListOfTicketStatus;
                            track item
                          ) {
                            <mat-option [value]="item.statusCode">
                              {{ item.status }}
                            </mat-option>
                          }
                        </mat-select>
                        @if (
                          updateTicketForm.controls['remarkbyaccolade']
                            .touched &&
                          updateTicketForm.controls['remarkbyaccolade'].errors
                            ?.required
                        ) {
                          <mat-error> This field is mandatory. </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="form-group">
                      <label for="Remark" class="form-label">Remark</label>
                      <mat-form-field appearance="outline">
                        <mat-label>Remark</mat-label>
                        <input
                          matInput
                          type="text"
                          formControlName="remark"
                          [matAutocomplete]="remarkAuto2"
                          type="text"
                        />
                        <mat-autocomplete #remarkAuto2="matAutocomplete">
                          @for (
                            option of filteredRemarks(
                              updateTicketForm.get('remark')?.value
                            );
                            track option
                          ) {
                            <mat-option [value]="option">
                              {{ option }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>
                    @if (
                      updateTicketForm.value.remarkbyaccolade === 'STS_CO_18'
                    ) {
                      <!-- Certificate File Uploads -->
                      <div class="form-group">
                        <label for="fileNames" class="form-label"
                          >Certificate File Uploads</label
                        >
                        <mat-form-field
                          class="file-upload-container"
                          appearance="outline"
                        >
                          <mat-label>Certificate File Uploads</mat-label>

                          <!-- Display File Name or Placeholder -->
                          <input
                            matInput
                            type="text"
                            formControlName="fileNames"
                            [value]="
                              updateTicketForm.controls['fileNames'].value
                            "
                            readonly
                          />

                          <!-- Hidden File Input -->
                          <input
                            type="file"
                            accept=".pdf"
                            multiple
                            aria-label="File"
                            class="d-none"
                            (change)="onFileChange($event, 'single')"
                            #fileInput
                          />

                          <!-- Custom Upload Button -->
                          <button
                            mat-button
                            class="upload-btn"
                            (click)="fileInput.click()"
                            type="button"
                          >
                            <mat-icon>attach_file</mat-icon>
                          </button>

                          <!-- Error Message -->
                          @if (
                            updateTicketForm.controls['fileNames'].touched &&
                            updateTicketForm.controls['fileNames'].errors
                              ?.required
                          ) {
                            <mat-error> This field is Mandatory. </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                  </div>
                </div>

                <!-- Separator between Body and Footer -->
                <div class="component-separator"></div>

                <div class="component-footer">
                  <div class="button-group">
                    <button
                      type="button"
                      class="submit-button"
                      (click)="submitUpdateTicketPopupModal()"
                    >
                      Submit
                      <mat-icon class="btn-icon">check_circle</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
